import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Chinese%20cinema%20atmosphere%20with%20warm%20golden%20red%20curtains%20and%20spotlight%2C%20elegant%20theater%20stage%20with%20modern%20digital%20screens%2C%20cinematic%20lighting%20with%20dramatic%20shadows%2C%20luxurious%20warm%20tones%2C%20entertainment%20platform%20hero%20background%2C%20grand%20and%20inviting%20atmosphere&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="国产在线观看 - 高清国产视频免费在线观看平台"
        title="国产在线观看 - 高清国产视频免费在线观看平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center animate-fade-in">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-2xl md:text-5xl font-bold text-background-50 mb-4 leading-tight animate-fade-in-up">
            高清国产视频
            <span className="text-accent-400">免费在线观看</span>
          </h1>
          <p className="text-sm md:text-lg text-background-200/90 mb-8 max-w-xl mx-auto leading-relaxed">
            海量国产影视剧、综艺、短片，无需下载，手机电脑多端流畅播放，每日更新，给你最极致的观看体验
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/dianshiju"
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap animate-scale-in animate-delay-300"
            >
              开始观看
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-full bg-background-50/15 text-background-50 font-medium text-sm hover:bg-background-50/25 backdrop-blur-sm transition-colors cursor-pointer whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-6 md:gap-10">
            {categories.slice(0, 4).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex flex-col items-center gap-1 text-background-50/80 hover:text-accent-400 transition-colors cursor-pointer group"
              >
                <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-50/15 group-hover:bg-accent-500/30 transition-colors">
                  <i className={`${cat.icon} text-lg md:text-xl`}></i>
                </span>
                <span className="text-xs font-medium whitespace-nowrap">{cat.name}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}